import { render, staticRenderFns } from "./infoPopup.vue?vue&type=template&id=06d6e0c2&scoped=true"
import script from "./infoPopup.vue?vue&type=script&lang=js"
export * from "./infoPopup.vue?vue&type=script&lang=js"
import style0 from "./infoPopup.vue?vue&type=style&index=0&id=06d6e0c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d6e0c2",
  null
  
)

export default component.exports